import {CompetitorRegistrationDto, RaceCommercialItem} from "@model";

export class RaceRegistrationRequestDto {
  teamName?: string;
  competitorRegistrations?: Array<CompetitorRegistrationDto>;
  receiptEmail?: string;
  raceId?: number;
  teamCommercialItem?: RaceCommercialItem;
  teamCoupon?: string;

  constructor(raceId?: number, competitorRegistrations?: Array<CompetitorRegistrationDto>, receiptEmail?: string,
              teamName?: string, teamCommercialItem?: RaceCommercialItem, teamCoupon?: string) {
    this.teamName = teamName;
    this.competitorRegistrations = competitorRegistrations;
    this.receiptEmail = receiptEmail;
    this.raceId = raceId;
    this.teamCommercialItem = teamCommercialItem;
    this.teamCoupon = teamCoupon;
  }
}
